export const BALANCE_BASE = 'BALANCE_BASE'
export const BALANCE_PAYMENTS_LIST = 'BALANCE_PAYMENTS_LIST'
export const BALANCE_LIST = 'BALANCE_LIST'
export const BALANCE_LIQPAY_SUCCESS = 'BALANCE_LIQPAY_SUCCESS'
